// Generated by Melange

import * as Stdlib__String from "melange/string.js";

function formatPhone(phone) {
  try {
    return Stdlib__String.sub(phone, 0, 2) + (" " + (Stdlib__String.sub(phone, 2, 3) + (" " + (Stdlib__String.sub(phone, 5, 3) + (" " + Stdlib__String.sub(phone, 8, 4))))));
  }
  catch (exn){
    return phone;
  }
}

export {
  formatPhone,
}
/* No side effect */
